
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/following",
      function () {
        return require("private-next-pages/dashboard/following.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/following"])
      });
    }
  